<template>
  <div>
    <portal target-el="#filter">
      <primary-filter
        :noSearchFilter="true" />
    </portal>
  </div>
</template>
<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';

export default {
  components: { PrimaryFilter },
  created() {
    const token = localStorage.getItem('tsm-user-token');
    const baseUrl = this.$route.query.serviceUrl;
    const hasFeature = this.$hasFeature('freight_audit_process');
    const hasPermission = this.$hasPermission('view_freight_audit_process');
    if (hasFeature && hasPermission) {
      const url = `https://${baseUrl}?token=${token}`;
      window.open(url, '_self');
    } else {
      this.$errorMessage({ message: this.$getErr('ERR_CONFIG_MISSING') });
    }
  },
};
</script>
